import { IndustryConfig, IndustryType } from '../../../types'
import { automotiveServicesConfig } from './automotive-services'
import { automotiveServicesExpansionConfig } from './automotive-services-expansion'
import { aviationAerospaceConfig } from './aviation-aerospace'
import { careerTransitionsPersonalServicesConfig } from './career-transitions-personal-services'
import { constructionEquipmentConfig } from './construction-equipment'
import { foodServiceFranchiseConfig } from './food-service-franchise'
import { healthWellnessServicesConfig } from './health-wellness-services'
import { healthcareDentalServicesConfig } from './healthcare-dental-services'
import { heavyEquipmentConfig } from './heavy-equipment'
import { manufacturingConfig } from './manufacturing'
import { professionalServicesConfig } from './professional-services'
import { realEstateProfessionalsConfig } from './real-estate-professionals'
import { technologySoftwareConsultingConfig } from './technology-software-consulting'
import { transportationLogisticsConfig } from './transportation-logistics'

export const industryConfigs: Record<IndustryType, IndustryConfig> = {
  'automotive-services': automotiveServicesConfig,
  'automotive-services-expansion': automotiveServicesExpansionConfig,
  'aviation-aerospace': aviationAerospaceConfig,
  'career-transitions-personal-services': careerTransitionsPersonalServicesConfig,
  'construction-equipment': constructionEquipmentConfig,
  'food-service-franchise': foodServiceFranchiseConfig,
  'health-wellness-services': healthWellnessServicesConfig,
  'healthcare-dental-services': healthcareDentalServicesConfig,
  'heavy-equipment': heavyEquipmentConfig,
  'manufacturing': manufacturingConfig,
  'professional-services': professionalServicesConfig,
  'real-estate-professionals': realEstateProfessionalsConfig,
  'technology-software-consulting': technologySoftwareConsultingConfig,
  'transportation-logistics': transportationLogisticsConfig
}

export const getIndustryConfig = (industry: IndustryType): IndustryConfig => {
  return industryConfigs[industry]
}

export const getAllIndustries = (): IndustryConfig[] => {
  return Object.values(industryConfigs)
}

export * from './automotive-services'
export * from './automotive-services-expansion'
export * from './aviation-aerospace'
export * from './career-transitions-personal-services'
export * from './construction-equipment'
export * from './food-service-franchise'
export * from './health-wellness-services'
export * from './healthcare-dental-services'
export * from './heavy-equipment'
export * from './manufacturing'
export * from './professional-services'
export * from './real-estate-professionals'
export * from './technology-software-consulting'
export * from './transportation-logistics'